module.exports = __webpack_public_path__ + "static/media/20_galeria_plantillas_combo_duo_cuad_19.3ab2de54.png";